import React from 'react';
import { Message, Segment } from 'semantic-ui-react';

import Button from '../../../components/Button';

type Props = {
  openKycLink: () => void;
  loadActivationStatus: () => void;
  activationLoading: boolean;
  activationKycPageUrl: string;
};

const KycBanner: React.FC<Props> = ({
  openKycLink,
  loadActivationStatus,
  activationLoading,
  activationKycPageUrl,
}) => {
  return (
    <Segment>
      <Message info style={{ marginBottom: 0 }}>
        <Message.Header>Biometria pendente na Pagar.me</Message.Header>
        <p>
          Enquanto a prova de vida não for concluída, não é possível criar novas cobranças.
        </p>
        {activationKycPageUrl && (
          <p style={{ marginBottom: 12 }}>
            <a href={activationKycPageUrl} target="_blank" rel="noopener noreferrer">
              Abrir página de biometria
            </a>
          </p>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button type="button" text="Abrir biometria" onClick={openKycLink} />
          <Button
            type="button"
            text="Atualizar status"
            light
            onClick={loadActivationStatus}
            loading={activationLoading}
            disabled={activationLoading}
          />
        </div>
      </Message>
    </Segment>
  );
};

export default KycBanner;
